module.exports = __webpack_public_path__ + "static/img/1074.f3ee330.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1074.jpg
// module id = 256
// module chunks = 0